import 'react-app-polyfill/ie11';
import './polyfill';
import { AUTH_TENANT, AUTH_CLIENT } from './config/config';

var validConfig = (AUTH_TENANT != null && AUTH_CLIENT != null);

console.log('Config: ' + (validConfig ? 'valid' : 'invalid'));

if (validConfig == true) {
    require('./indexAppWithADAL.js');
} else {
    require('./indexApp.js');
}




// WEBPACK FOOTER //
// ./src/index.js